const FUNNEL_STATUS_LABELS = {
    new: 'New',
    discarded: 'Discarded',
    prospect: 'Prospect',
    crawled: 'Crawled',
    contact_extracted: 'Contacts',
    captured: 'Captured',
    analyzed: 'Analyzed',
    ready_for_outreach: 'Ready',
    qualified: 'Qualified',
    proposal: 'Proposal',
    won: 'Won',
};

const FUNNEL_STATUS_COLORS = {
    new: '#9CA3AF',        // Gray
    discarded: '#EF4444',   // Red
    prospect: '#3B82F6',    // Blue
    crawled: '#60A5FA',     // Light Blue
    contact_extracted: '#22D3EE', // Cyan
    captured: '#06B6D4',    // Darker Cyan
    analyzed: '#14B8A6',   // Teal
    ready_for_outreach: '#A78BFA', // Purple
    qualified: '#10B981',  // Green
    proposal: '#F59E0B',   // Amber
    won: '#16A34A',         // Dark Green
};

const PIPELINE_ORDER = [
    'new',
    'discarded',
    'prospect',
    'crawled',
    'contact_extracted',
    'captured',
    'analyzed',
    'ready_for_outreach',
    'qualified',
    'proposal',
    'won',
];

export { FUNNEL_STATUS_LABELS, FUNNEL_STATUS_COLORS, PIPELINE_ORDER };
